import { useCallback, useEffect, useState } from "react";
import { fetchFastApi } from "../api/fastapi";
import { ApprovalRequest, ApprovalRequestSchema } from "../models/approval";
import { z } from "zod";

const ApprovalHistoryResponseSchema = z.object({
  history: z.array(ApprovalRequestSchema),
});

export const useApprovalHistory = (
  entityType: string | null,
  entityId: string | null,
) => {
  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState<ApprovalRequest[]>([]);

  const fetchHistory = useCallback(async () => {
    if (!entityType || !entityId) return;

    setLoading(true);
    try {
      const data = await fetchFastApi({
        path: `/approvals/requests/entity/${entityType}/${entityId}/history`,
        method: "GET",
      });

      const parsed = ApprovalHistoryResponseSchema.parse(data);
      setHistory(parsed.history);
    } catch (error) {
      console.error("Failed to fetch approval history:", error);
      setHistory([]);
    } finally {
      setLoading(false);
    }
  }, [entityType, entityId]);

  useEffect(() => {
    fetchHistory();
  }, [fetchHistory]);

  return {
    loading,
    history,
    fetchHistory,
  };
};
